import { getLocationHostname } from '../../modules/app/actions';
import { DistributorPromiseThunkAction } from '../../types';
import { setFeatureFlagServiceScopeLoading, setFeatureFlagServiceScopeLoadingFinished } from './reducer';
import { getFeatureFlagServiceUserConfiguration } from './selectors';

const setFeatureFlagServiceUser =
    (enterpriseId: string): DistributorPromiseThunkAction =>
    async (dispatch, getState, { featureFlagService, loggerService }) => {
        try {
            dispatch(setFeatureFlagServiceScopeLoading());
            const hostname = dispatch(getLocationHostname());
            const featureFlagUser = getFeatureFlagServiceUserConfiguration(getState(), {
                enterpriseId,
                hostname,
            });
            await featureFlagService.setUser(featureFlagUser);
        } catch (error) {
            loggerService.log('featureFlagService', 'User setting failed.', {
                enterpriseId,
                error,
            });
        } finally {
            dispatch(setFeatureFlagServiceScopeLoadingFinished());
        }
    };

export const setEnterpriseToolingData =
    (enterpriseId: string): DistributorPromiseThunkAction =>
    async (dispatch) =>
        dispatch(setFeatureFlagServiceUser(enterpriseId));

/**
 * Set tooling data for multiple enterprises. This is mainly for the first screen of booking engine where we don't have selected enterpriseId yet.
 */
export const setMultiPropertyToolingData =
    (enterpriseIds: string[]): DistributorPromiseThunkAction =>
    async (dispatch, _getState, { featureFlagService, loggerService }) => {
        try {
            dispatch(setFeatureFlagServiceScopeLoading());
            const hostname = dispatch(getLocationHostname());
            const featureFlagUser = {
                anonymous: true,
                custom: {
                    enterpriseIds,
                    hostname,
                },
            };
            await featureFlagService.setUser(featureFlagUser);
        } catch (error) {
            loggerService.log('featureFlagService', 'User setting failed.', {
                enterpriseIds,
                error,
            });
        } finally {
            dispatch(setFeatureFlagServiceScopeLoadingFinished());
        }
    };
